import React from "react";
import "./TermsCondition.css";

function Terms() {

  return (

    <section className="terms-section">

      {/* Heading */}

      <div className="terms-heading">

        <span>Terms & Conditions</span>

        <h1>
          Chennai Washcare <br />
          Terms & Conditions
        </h1>

        <p>
          Please read these terms and conditions carefully before
          using Chennai Washcare services and website.
        </p>

      </div>

      {/* Content */}

      <div className="terms-container">

        {/* Card 1 */}

        <div className="terms-card">

          <h2>1. Service Agreement</h2>

          <p>
            By booking a service with Chennai Washcare, customers agree
            to provide accurate service details, contact information and
            address for technician visits and support.
          </p>

        </div>

        {/* Card 2 */}

        <div className="terms-card">

          <h2>2. Inspection & Repair</h2>

          <p>
            Washing machine issues will be inspected by our technician.
            Final repair charges may vary depending on machine condition,
            spare parts replacement and repair complexity.
          </p>

        </div>

        {/* Card 3 */}

        <div className="terms-card">

          <h2>3. Spare Parts</h2>

          <p>
            Chennai Washcare may use genuine or compatible spare parts
            based on availability and customer approval during service.
          </p>

        </div>

        {/* Card 4 */}

        <div className="terms-card">

          <h2>4. Warranty Support</h2>

          <p>
            Limited warranty may be provided for selected repairs and
            spare parts. Warranty does not cover physical damage,
            electrical fluctuation or customer misuse.
          </p>

        </div>

        {/* Card 5 */}

        <div className="terms-card">

          <h2>5. Payment Terms</h2>

          <p>
            Customers must complete payment after service completion.
            Service charges may include inspection charges, labor charges
            and spare parts cost.
          </p>

        </div>

        {/* Card 6 */}

        <div className="terms-card">

          <h2>6. Service Cancellation</h2>

          <p>
            Customers may cancel or reschedule service requests before
            technician dispatch. Chennai Washcare reserves the right to
            cancel services due to unavoidable situations.
          </p>

        </div>

        {/* Card 7 */}

        <div className="terms-card">

          <h2>7. Customer Responsibility</h2>

          <p>
            Customers are responsible for ensuring proper electrical
            connection, water supply and safe working conditions during
            washing machine inspection and repair.
          </p>

        </div>

        {/* Card 8 */}

        <div className="terms-card">

          <h2>8. Website Usage</h2>

          <p>
            Customers should not misuse the Chennai Washcare website,
            submit false service requests or attempt unauthorized access
            to website systems or information.
          </p>

        </div>

        {/* Card 9 */}

        <div className="terms-card">

          <h2>9. Terms Updates</h2>

          <p>
            Chennai Washcare may update or modify these Terms &
            Conditions at any time without prior notice.
          </p>

        </div>

        {/* Contact */}

        <div className="terms-card">

          <h2>10. Contact Information</h2>

          <p>
            For any questions regarding Terms & Conditions, customers
            may contact Chennai Washcare support.
          </p>

          <div className="terms-contact-box">

            <p>
              📞+91 9790066906
            </p>

            <p>
              ✉️ chennaiwashcare210@gmail.com
            </p>

            <p>
              📍 Saidapet, Chennai, Tamil Nadu - 600015
            </p>

          </div>

        </div>

      </div>

    </section>

  );

}

export default Terms;